import React, { useState } from "react";
import {
  Flex,
  Box,
  Text,
  Card,
  CardBody,
  SimpleGrid,
  Tooltip,
  Divider,
  useMediaQuery,
} from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import Navbar from "../components/nav/index";
import { ReactComponent as ExpressIcon } from "../assets/icons/expressjs.svg";
import { ReactComponent as ReactIcon } from "../assets/icons/reactjs.svg";
import { ReactComponent as MongoDBIcon } from "../assets/icons/mongodb.svg";
import { ReactComponent as JavascriptIcon } from "../assets/icons/javascript.svg";
import { ReactComponent as NodejsIcon } from "../assets/icons/nodejs.svg";
import { ReactComponent as PythonIcon } from "../assets/icons/python.svg";
import { ReactComponent as DockerIcon } from "../assets/icons/docker.svg";
import { ReactComponent as FlaskIcon } from "../assets/icons/flask.svg";
import { ReactComponent as FastAPIIcon } from "../assets/icons/fastapi.svg";
import { ReactComponent as CrewAIIcon } from "../assets/icons/crewai.svg";
import { ReactComponent as PineconeIcon } from "../assets/icons/pinecone.svg";
import { ReactComponent as HTMLIcon } from "../assets/icons/html.svg";
import { ReactComponent as CSSIcon } from "../assets/icons/css.svg";
import { ReactComponent as AWSIcon } from "../assets/icons/aws.svg";

const slideInLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;

const educationList = [
  {
    name: "Lahore University of Management Sciences",
    degree: "Bachelors in Computer Science",
    duration: "2019 - 2023",
    course: "Computer Science",
  },
  {
    name: "Lahore Grammar School (Johar Town)",
    degree: "Advance Levels",
    duration: "2017 - 2019",
    course: "Sciences",
  },
  {
    name: "Lahore Grammar School (Johar Town)",
    degree: "Ordinary Levels",
    duration: "2014 - 2017",
    course: "Sciences",
  },
];

const skillList = {
  HTML: <HTMLIcon width="100%" height="100%" />,
  CSS: <CSSIcon width="100%" height="100%" />,
  Javascript: <JavascriptIcon width="100%" height="100%" />,
  "React js": <ReactIcon width="100%" height="100%" />,
  "Node js": <NodejsIcon width="100%" height="100%" />,
  "Express js": <ExpressIcon width="100%" height="100%" />,
  "Mongo DB": <MongoDBIcon width="100%" height="100%" />,
  Python: <PythonIcon width="100%" height="100%" />,
  Flask: <FlaskIcon width="100%" height="100%" />,
  "Fast API": <FastAPIIcon width="100%" height="100%" />,
  "Crew AI": <CrewAIIcon width="100%" height="100%" />,
  Pinecone: <PineconeIcon width="100%" height="100%" />,
  "Amazon Web Services": <AWSIcon width="100%" height="100%" />,
  Docker: <DockerIcon width="100%" height="100%" />,
};

const navList = ["About Me", "Skills", "Education"];
const aboutMeDetails = {
  Name: "Moiz Nafey",
  Age: "24",
  Phone: "+92 302 6402646",
  Nationality: "Pakistani",
  Email: "nafeymoiz@gmail.com",
  Experience: "2+ Years",
  Languages: "English, Urdu",
};
const About = () => {
  const [isLargerThanMobileSize] = useMediaQuery("(min-width: 768px)");
  const [selectedNavItem, setSelectedNavItem] = useState("About Me");
  return (
    <Box backgroundColor={"#000000"} gap={20} minHeight={"100vh"}>
      <Flex direction={"column"}>
        <Navbar />
        <Flex
          margin={{ base: 5, lg: 10, xl: 20 }}
          justifyContent={"space-between"}
          color={"gray.300"}
          direction={isLargerThanMobileSize ? "row" : "column"}
          alignItems={isLargerThanMobileSize ? "" : "center"}
          gap={isLargerThanMobileSize ? 0 : 10}
        >
          <Flex
            direction={"column"}
            width={isLargerThanMobileSize ? "30%" : "100%"}
            gap={5}
          >
            <Text fontSize={"4xl"} textAlign={{ base: "center", lg: "left" }}>
              Why Hire Me?
            </Text>

            <Text textAlign={{ base: "center", lg: "left" }}>
              As a dedicated and versatile full-stack software engineer, I bring
              a comprehensive skill set that bridges both front-end and back-end
              development, ensuring seamless integration and exceptional user
              experiences.
            </Text>

            {navList.map((item) => (
              <Card
                _hover={{ cursor: "pointer" }}
                backgroundColor={
                  item === selectedNavItem ? "#34A9A7" : "gray.100"
                }
                color={item === selectedNavItem ? "white" : "black"}
                onClick={() => setSelectedNavItem(item)}
                key={item}
                marginX={isLargerThanMobileSize ? 0 : 24}
              >
                <CardBody p={3}>
                  <Flex justifyContent={"center"}>
                    <Text>{item}</Text>
                  </Flex>
                </CardBody>
              </Card>
            ))}
          </Flex>

          {selectedNavItem === "About Me" && <AboutMeContent />}
          {selectedNavItem === "Skills" && <SkillsContent />}
          {selectedNavItem === "Education" && <EducationContent />}
        </Flex>
      </Flex>
    </Box>
  );
};

export default About;

export const AboutMeContent = () => {
  const [isLargerThanMobileSize] = useMediaQuery("(min-width: 768px)");
  return (
    <Flex
      direction={"column"}
      width={isLargerThanMobileSize ? "50%" : "100%"}
      gap={5}
      animation={`${slideInLeft} 1s ease-out forwards`}
    >
      <Text fontSize={"4xl"} textAlign={{ base: "center", lg: "left" }}>
        About Me
      </Text>
      <Text textAlign={{ base: "center", lg: "left" }}>
        As a dedicated and versatile full-stack software engineer, I bring a
        comprehensive skill set that bridges both front-end and back-end
        development, ensuring seamless integration and exceptional user
        experiences.
      </Text>
      <SimpleGrid columns={2} spacing={5}>
        {Object.entries(aboutMeDetails).map(([key, value]) => (
          <Text key={key}>
            <Text as="span" color={"gray.400"}>
              {key}:
            </Text>{" "}
            {value}
          </Text>
        ))}
      </SimpleGrid>
    </Flex>
  );
};

export const SkillsContent = () => {
  const [isLargerThanMobileSize] = useMediaQuery("(min-width: 768px)");
  return (
    <Flex
      direction={"column"}
      width={isLargerThanMobileSize ? "50%" : "100%"}
      gap={5}
      animation={`${slideInLeft} 1s ease-out forwards`}
    >
      <Text fontSize={"4xl"} textAlign={{ base: "center", lg: "left" }}>
        Skills
      </Text>
      <Text textAlign={{ base: "center", lg: "left" }}>
        I'm passionate about creating strong applications using Node.js,
        Express.js, and React.js. I love working with Python and Flask to build
        flexible web solutions, and I rely on MongoDB for efficient data
        management. Plus, I use Docker to make deployment a breeze, and I'm
        comfortable crafting responsive designs with HTML and CSS.
      </Text>
      <SimpleGrid minChildWidth={"100px"} spacing={5}>
        {Object.entries(skillList).map(([key, value]) => (
          <Tooltip key={key} label={key}>
            <Box
              borderRadius={"xl"}
              padding={5}
              key={key}
              backgroundColor={"white"}
              boxShadow={"md"}
              _hover={{
                boxShadow: "xl",
                transform: "translateY(-5px) scale(1.05)",
                transition: "all 0.3s ease-in-out",
              }}
            >
              {value}
            </Box>
          </Tooltip>
        ))}
      </SimpleGrid>
    </Flex>
  );
};

export const EducationContent = () => {
  const [isLargerThanMobileSize] = useMediaQuery("(min-width: 768px)");
  const [hoveredIndex, setHoveredIndex] = useState(null);
  return (
    <Flex
      direction={"column"}
      width={isLargerThanMobileSize ? "50%" : "100%"}
      gap={5}
      animation={`${slideInLeft} 1s ease-out forwards`}
      alignItems={isLargerThanMobileSize ? "" : "center"}
    >
      <Text fontSize={"4xl"} textAlign={{ base: "center", lg: "left" }}>
        Education
      </Text>

      <Flex gap={3}>
        <Flex direction={"column"} alignItems={"center"}>
          {educationList.map((item, index) => {
            return (
              <>
                <Box
                  key={index}
                  height={"10px"}
                  width={"10px"}
                  backgroundColor={
                    hoveredIndex === index ? "#34A9A7" : "gray.400"
                  }
                  borderRadius={"full"}
                ></Box>
                <Divider orientation="vertical" color={"red"} height={"33%"} />
              </>
            );
          })}
        </Flex>

        <Flex direction={"column"} gap={5}>
          {educationList.map((item, index) => (
            <Flex gap={2} key={index}>
              <Card
                flexGrow={1}
                borderRadius={"xl"}
                boxShadow={"md"}
                _hover={{
                  boxShadow: "xl",
                  transform: "scaleY(1.05)",
                  transition: "transform 0.3s ease-in-out",
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <CardBody>
                  <Flex direction={"column"} gap={3}>
                    <Text
                      fontSize={{ base: "sm", md: "lg" }}
                      fontWeight={"bold"}
                    >
                      {item.degree}
                    </Text>
                    <Flex direction={"column"} gap={1}>
                      <Text fontSize={{ base: "xs", md: "sm" }}>
                        <Text
                          as="span"
                          color={"gray.600"}
                          fontSize={{ base: "xs", md: "sm" }}
                        >
                          Institute:
                        </Text>{" "}
                        {item.name}
                      </Text>
                      <Text fontSize={{ base: "xs", md: "sm" }}>
                        <Text
                          as="span"
                          color={"gray.600"}
                          fontSize={{ base: "xs", md: "sm" }}
                        >
                          Course:
                        </Text>{" "}
                        {item.course}
                      </Text>
                      <Text fontSize={{ base: "xs", md: "sm" }}>
                        <Text
                          as="span"
                          color={"gray.600"}
                          fontSize={{ base: "xs", md: "sm" }}
                        >
                          Duration:
                        </Text>{" "}
                        {item.duration}
                      </Text>
                    </Flex>
                  </Flex>
                </CardBody>
              </Card>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};
